import type { FC } from 'react';

import { ChatBubbleIcon } from '@/assets';
import { LabelButton } from '@/features/posts/components/LabelButton';
import { PostsRoute } from '@/features/posts/navigation/postsRoute';
import { useAppNavigation } from '@/navigation/hooks/useAppNavigation';

type CommentButtonProps = {
  postId?: string;
  commentCount?: number;
};

export const CommentButton: FC<CommentButtonProps> = ({
  postId = '',
  commentCount = 0
}) => {
  const navigation = useAppNavigation();

  return (
    <LabelButton
      testID={`post-comment-button-${postId}`}
      onPress={() =>
        postId && navigation.navigate(PostsRoute.PostDetail, { id: postId })
      }
      rippleColor="transparent"
      icon={({ color, size }) => (
        <ChatBubbleIcon fill={color} width={size} height={size} />
      )}
    >
      {commentCount}
    </LabelButton>
  );
};
